module.exports = __webpack_public_path__ + "d4e68c3c8c374b3d5486791b820d7afe.MP3";